'use strict'

export const Promise = global.Promise || require('promise-polyfill')

export default Promise
